var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"userCard"},'div',_vm.initSocketEvents,false),[_c('UserList',{attrs:{"styleTitle":true,"title":"Monitores","subtitle":"Lista de monitores con sus respectivas modelos oficiales","users":_vm.users,"pagination":_vm.pagination,"hasFinder":true},on:{"getMoreUsers":_vm.getMoreUsers,"onSearch":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }